import { useState } from "react";
import { FaUser, FaLock, FaArrowRight } from "react-icons/fa";
import { ImEyeMinus, ImEyePlus } from "react-icons/im";
import { motion } from "framer-motion";
import logo from "../../images/logo/logo.png";
import { LoginAPI } from "../../utlis/apiService";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import InputField from "../../common/InputField";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await LoginAPI.loginUser(username, password);
      if (response.token) {
        // Cookies.set("token", response.token, { expires: 7, path: "/" });
        sessionStorage.setItem("user", JSON.stringify(response));
        navigate("/dashboard");
      } else {
        alert("Invalid login. Please check your credentials.");
      }
    } catch (error) {
      alert("Login failed.");
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none ">
        {[...Array(75)].map((_, i) => {
          const size = Math.random() * 6 + 4;
          const radius = Math.random() * 20 + 10;
          return (
            <div
              key={i}
              className="absolute animate-orbit"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                width: `${radius * 2}px`,
                height: `${radius * 2}px`,
                animationDuration: `${4 + Math.random() * 4}s`,
                animationDelay: `${Math.random() * 2}s`,
              }}
            >
              <div
                className="bg-primary rounded-full absolute"
                style={{
                  width: `${size}px`,
                  height: `${size}px`,
                  top: `0`,
                  left: `50%`,
                  transform: `translateX(-50%)`,
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="relative flex items-center justify-center h-screen my-auto">
        <div className="w-[400px] h-auto z-10">
          <div className="flex items-center justify-center bg-cover">
            <div className="relative w-full h-[500px] bg-white shadow-2xl overflow-hidden rounded-3xl ">
              {/* Content */}
              <div className="relative z-10 p-10 pt-18">
                <form className="space-y-10" onSubmit={handleLogin}>
                  <div className="text-center">
                    <img src={logo} alt="Logo" className="h-10 mx-auto mb-6" />
                    <h1 className="text-primary text-2xl font-semibold">
                      Welcome Back
                    </h1>
                  </div>
                  {/* Username Field */}
                  <div className="flex items-center border-b border-gray-300 pb-2 px-2">
                    <FaUser className="text-primary mr-3 text-lg" />
                    <input
                      placeholder="User name / Email"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="focus:outline-none flex-1 text-base placeholder-gray-400 placeholder-text-base"
                    />
                  </div>

                  {/* Password Field */}
                  <div className="flex items-center border-b border-gray-300 pb-2 px-2">
                    <FaLock className="text-primary mr-3 text-lg" />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="focus:outline-none flex-1 text-base placeholder-gray-400 placeholder-text-base"
                    />
                    <button
                      type="button"
                      className="ml-2 text-primary focus:outline-none"
                      onClick={() => setShowPassword(!showPassword)}
                      title={showPassword ? "Hide Password" : "Show Password"}
                    >
                      {showPassword ? (
                        <ImEyePlus className="h-5 w-5" />
                      ) : (
                        <ImEyeMinus className="h-5 w-5" />
                      )}
                    </button>
                  </div>

                  <motion.div
                    initial={{ x: 0 }}
                    whileHover="hover"
                    transition={{ type: "spring", stiffness: 300 }}
                    className="w-full"
                  >
                    <button
                      type="submit"
                      className="w-full bg-primary border uppercase text-white rounded-full py-3 font-semibold flex justify-center items-center gap-3 "
                    >
                      log in now
                      <motion.div
                        variants={{
                          hover: { x: 6 },
                        }}
                        transition={{ type: "spring", stiffness: 300 }}
                      >
                        <FaArrowRight />
                      </motion.div>
                    </button>
                  </motion.div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div
          className="absolute top-auto left-auto w-[420px] h-[540px]
                bg-gradient-to-b from-secondary/20 to-primary
                rounded-3xl rotate-6 z-0 opacity-40 shadow-2xl"
        />
      </div>
      <style>
        {`
             @keyframes orbit {
  0% {
    transform: rotate(0deg);
    opacity:0;
  }
  100% {
    transform: rotate(360deg);
  }
}
.animate-orbit {
  animation: orbit linear infinite;
  transform-origin: center center;
  position: absolute;
}
      `}
      </style>
    </>
  );
};
export default Login;
